// "Fact of the day" on Home (owner, 2026-09-27): one fact a day, the next
// at the keeper's own midnight, and no way to skip ahead. Learning one and
// sitting with it beats paging through the pool until it runs out.

// Days since the epoch in the device's own time zone, so the fact turns
// over at local midnight, not UTC midnight.
export function localDayNumber(date = new Date()) {
  return Math.floor((date.getTime() - date.getTimezoneOffset() * 60_000) / 86_400_000);
}

export function msUntilLocalMidnight(date = new Date()) {
  const next = new Date(date);
  next.setHours(24, 0, 0, 0);
  return next.getTime() - date.getTime();
}

// Today's fact. Once picked it is kept for the rest of the day (`pinned`,
// from storage), so a pool refreshed mid-day never swaps it under the
// keeper.
export function factForDay(tips, day, pinned = null) {
  if (pinned && pinned.day === day && pinned.heading && pinned.body) {
    return { heading: pinned.heading, body: pinned.body };
  }
  const usable = (tips || []).filter((t) => t?.heading && t?.body);
  if (!usable.length) return null;
  const t = usable[((day % usable.length) + usable.length) % usable.length];
  return { heading: t.heading, body: t.body };
}
